module.exports = __webpack_public_path__ + "img/wallet-fill.baed1954.svg";